import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SpinnerModule } from 'cre-ng';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';

import { CoreModule } from '@app/core';
import { SharedModule } from '@app/shared';
import { PhonePipe } from './phone.pipe';
import { SearchComponent } from './search.component';
import { SearchService } from './search.service';

@NgModule({
  imports: [
    ButtonModule,
    CommonModule,
    CoreModule,
    FormsModule,
    InputTextModule,
    ReactiveFormsModule,
    SharedModule,
    SpinnerModule,
    TableModule,
    TabViewModule,
  ],
  exports: [SearchComponent],
  declarations: [SearchComponent, PhonePipe],
  providers: [SearchService],
})
export class SearchModule {}
